import { baseApi } from 'api'

export const documentApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    downloadInvoice: build.query<string, string>({
      query: (id) => ({
        url: `doc/invoice/order/${id}`,
        responseHandler: async (response) => {
          const blob = await response.blob()

          return { blob }
        }
      })
    }),
    downloadAssignment: build.query<string, string>({
      query: (id) => ({
        url: `doc/assignment/order/${id}`,
        responseHandler: async (response) => {
          const blob = await response.blob()

          return { blob }
        }
      })
    })
  }),
  overrideExisting: false
})

export const { useDownloadInvoiceQuery, useDownloadAssignmentQuery } = documentApi
